import { getImageUrl } from '@/utils/image'
import Head from '@/components/head'

const GenericCompanyMeta = ({
  companyData,
  companyId,
  listings,
  companyCity,
  companyName,
  agentName,
  isLoading,
  metadata
}) => {
  if (isLoading || !companyData || !companyId) return null

  const urlPath = `/company/${companyId}`
  const title = companyName
    ? `Houses, Rooms and Apartments For Rent | ${companyName}`
    : `${agentName} listings for rent`
  const pageDescription =
    companyData.seoTitle ||
    `View available rentals from ${
      companyName || agentName
    } on liv.rent. Search hundreds of apartments and houses for rent ${
      companyCity ? `in ${companyCity} and ` : ''
    }across Canada.`

  const metaImageUrl = getImageUrl(
    listings[0]?.cover_photo_aws_s3_key || null,
    {
      width: 1200,
      height: 630,
      quality: 80
    }
  )

  return (
    <Head
      title={`${title} | liv.rent`}
      description={pageDescription}
      meta={{
        image: metaImageUrl,
        imageAlt: companyData.seoImageAlt || title
      }}
      path={urlPath}
      pageData={metadata}
      hideCustomerSupport
    />
  )
}

export default GenericCompanyMeta
